// Asynchronous Button Loading State, Spinners & Duplicate Submission Mutex
// Conforms to Story 9.7 AC4

const SPINNER_SVG = '<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-current inline shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>'

export function initAsyncButtonMutex () {
  if (typeof document === 'undefined') return

  // Prevent duplicate submissions on Turbo forms
  document.addEventListener('turbo:submit-start', (event) => {
    const form = event.target
    const submitter = event.detail?.formSubmission?.submitter || form.querySelector('button[type="submit"], input[type="submit"]')
    if (!submitter) return

    if (submitter.dataset.submitting === 'true') {
      event.preventDefault()
      return
    }

    submitter.dataset.submitting = 'true'
    submitter.dataset.originalHtml = submitter.innerHTML
    submitter.disabled = true
    submitter.classList.add('opacity-75', 'cursor-not-allowed', 'pointer-events-none')

    const label = submitter.textContent.trim()
    submitter.innerHTML = `${SPINNER_SVG}<span>${label}</span>`
  })

  document.addEventListener('turbo:submit-end', (event) => {
    const form = event.target
    const submitter = event.detail?.formSubmission?.submitter || form?.querySelector?.('button[type="submit"], input[type="submit"]')
    if (!submitter || !submitter.dataset.originalHtml) return

    // Restore original state if still in DOM
    submitter.innerHTML = submitter.dataset.originalHtml
    delete submitter.dataset.originalHtml
    delete submitter.dataset.submitting
    submitter.disabled = false
    submitter.classList.remove('opacity-75', 'cursor-not-allowed', 'pointer-events-none')
  })
}
